
// src/components/exams/ExamManagement/CreateExam.jsx
import React, { useState } from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '../../../components/forms/Buttons/Button';

// Presentation-only class tokens
const controlCls =
  'block w-full rounded-lg border-slate-300 text-sm text-slate-900 shadow-sm transition duration-200 placeholder:text-slate-400 hover:border-slate-400 focus:border-blue-600 focus:ring-4 focus:ring-blue-600/15';
const labelCls = 'mb-1.5 block text-sm font-medium text-slate-700';

const CreateExam = ({ onCreateExam, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    category: ''
  });

  const categories = [
    'Вступительные экзамены',
    'Профессиональные тесты',
    'Технические тесты',
    'Сертификация',
    'Общие'
  ];

  const handleSubmit = () => {
    if (formData.name.trim()) {
      onCreateExam(formData);
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', description: '', category: '' });
    onCancel();
  };

  return (
    <div className="w-full motion-safe:animate-fade-in">
      <button
        onClick={onCancel}
        className="mb-4 -ml-2 inline-flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-sm font-medium text-slate-500 transition duration-200 hover:bg-slate-100 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      >
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
        Назад к экзаменам
      </button>
      
      <div className="max-w-3xl rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
        <h1 className="mb-6 text-2xl font-semibold tracking-tight text-slate-900">Создать новый экзамен</h1>
        
        <div className="max-w-2xl space-y-5">
          <div>
            <label className={labelCls}>
              Название экзамена *
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className={`${controlCls} h-10 px-3`}
              placeholder="Введите название экзамена"
            />
          </div>
          
          <div>
            <label className={labelCls}>
              Описание
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows="4"
              className={`${controlCls} resize-none px-3 py-2`}
              placeholder="Описание экзамена"
            />
          </div>

          <div>
            <label className={labelCls}>
              Категория
            </label>
            <select
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              className={`${controlCls} h-10 py-0 pl-3 pr-10`}
            >
              <option value="">Выберите категорию</option>
              {categories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>
          </div>
          
          <div className="flex flex-col gap-3 border-t border-slate-100 pt-6 sm:flex-row">
            <Button
              color="primary"
              onClick={handleSubmit}
              className="text-sm"
            >
              Создать экзамен
            </Button>
            <Button
              color="secondary-outline"
              onClick={handleCancel}
              className="text-sm"
            >
              Отмена
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateExam;
